import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { getClientToken, onMessageListener } from "../../fireBaseConfig/firebaseInit";
import "react-toastify/dist/ReactToastify.css";
import { LocalStorageKeys } from "../../common/constant/constantKey";
import useToken from "../account/login/useToken";
import { NotificationContext } from '../../context/notification.context';
const Notifications = () => {
  const { setHasNoti } = React.useContext(NotificationContext)
  const [isTokenFound, setTokenFound] = useState(false);
  const { token } = useToken();
  // To load once
  useEffect(() => {
    let data;
    async function tokenFunc() {
      data = await getClientToken(setTokenFound);
      localStorage.setItem(LocalStorageKeys.TokenFireBase, data)
      return data;
    }
    tokenFunc();
  }, [isTokenFound]);
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState({ title: "", body: "" });
  
  onMessageListener().then((payload) => {
    setShow(true);
    setNotification({
      title: payload.notification?.title || "",
      body: payload.notification?.body || "",
    });
    setHasNoti(true)
  }).catch((err) => console.log("failed: ", err));

  let hideNotif = notification.title === "";
  if (!hideNotif) {
    toast.info(<Display />);
  }

  function Display() {
    if (!token) return (<></>)
    return (
      <div>
        {notification.body}
      </div>
    );
  }
  return (
    <>
      {show && (
        <ToastContainer
          autoClose={6000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover={false}
        />
      )}
    </>);
};
export default Notifications;
